module.exports = __webpack_public_path__ + "pc/img/swiper_01.78e04c4f.jpg";